export default __webpack_public_path__ + "static/media/weights.d415d66b.png";